import { defineMessages } from 'react-intl';

export const tenantUsersTableMessages = defineMessages({
  userType: {
    defaultMessage: 'User Type',
  },
  name: {
    defaultMessage: 'Name',
  },
  email: {
    defaultMessage: 'Email',
  },
  phoneNumber: {
    defaultMessage: 'Phone Number',
  },
  status: {
    defaultMessage: 'Status',
  },
  smsAlert: {
    defaultMessage: 'SMS',
  },
  emailAlert: {
    defaultMessage: 'E-mail',
  },
  invite: {
    defaultMessage: 'Invite',
  },
  edit: {
    defaultMessage: 'Edit',
  },
  delete: {
    defaultMessage: 'Delete',
  },
  deleteConfirmation: {
    defaultMessage: 'Are you sure you want to delete?',
  },
  resetPassword: {
    defaultMessage: 'Reset Password',
  },
  resendInvite: {
    defaultMessage: 'Resend invite',
  },
  medicalAlerts: {
    defaultMessage: 'Medical Notifications',
  },
  technicalAlerts: {
    defaultMessage: 'Connectivity Notifications',
  },
  activityAlerts: {
    defaultMessage: 'Bed Activity Notifications',
  },
});
